import http, { apiErrorMessage, descargarExcelPorToken } from '../../http';

const vRutaGuiasUnidad = 'guias-unidad/';

export const LimpiarNombreExcel = () =>{
    return (dispatch, getState) => {
        dispatch({type: "EXCEL_LIMPIAR"});
    }
}

export const LimpiarData = () =>{
    return (dispatch, getState) => {
        dispatch({type: "GUIASUNIDAD_LIST_GUIAS_LIMPIAR_DATA"});
    }
}

export const getDatosBitacora = (bitacora) =>{
    return (dispatch, getState)=>{
        http.get(vRutaGuiasUnidad + 'bitacoras/' + encodeURIComponent(bitacora))
        .then(function (response){
            // Envelope v1: {data:{fecha,ruta,conductor,...}} -> la vista lee .resultado
            dispatch({
                type: "DATOSBITACORA_SUCCESS", payload: {
                    data: { resultado: response.data.data },
                }
            });
        })
        .catch(function (error) {
            dispatch({ type: 'DATOSBITACORA_ERROR', payload: { error: apiErrorMessage(error) } });
        })
        .finally(function () {
            //dispatch({ type: 'HIDE_LOADING' });
        });
    }
}

export const getExcelGuias = (bitacora, unidad) => {
    return (dispatch, getState) => {
        http.post(vRutaGuiasUnidad + 'excel', { bitacora, unidad })
            .then(function (response){
                // Envelope v1: {data:{nombreexcel,fileToken}}; el token firma la descarga
                dispatch({
                    type: "EXCEL_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

// Descarga autenticada del .xlsx de un solo uso generado por getExcelGuias.
export const descargarExcel = (excel) => {
    return (dispatch, getState) => {
        descargarExcelPorToken('guias-unidad', excel.fileToken, excel.nombreexcel)
            .catch(function (error) {
                dispatch({ type: 'EXCEL_ERROR', payload: { error: apiErrorMessage(error) } });
            });
    }
}

export const getGuiasBitacora = (bitacora) => {
    return (dispatch, getState) => {
        http.get(vRutaGuiasUnidad + 'bitacoras/' + encodeURIComponent(bitacora) + '/guias')
            .then(function (response){
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "GUIASUNIDAD_LIST_GUIAS_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'GUIASUNIDAD_LIST_GUIAS_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getListForTable = (unidad, fechainicio, fechafin) => {
    return (dispatch, getState) => {
        http.get(vRutaGuiasUnidad + 'bitacoras', { params: { unidad, fechaInicio: fechainicio, fechaFin: fechafin } })
            .then(function (response){
                // Envelope v1 dataTable: {data:{rows:[...]}} -> la vista espera {data:[...]}
                dispatch({
                    type: "UNIDADES_LIST_SUCCESS", payload: {
                        data: { data: response.data.data.rows },
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'UNIDADES_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            }
        );
    }
}

export const getUnidadesForaneas = () => {
    return (dispatch, getState) => {
        http.get('catalogos/unidades', { params: { tipoRuta: 'FORANEA' } })
            .then(function (response){
                // Envelope v1: {data:[{value,label},...]} (options del react-select)
                dispatch({
                    type: "UNIDADESFORANEAS_LIST_SUCCESS", payload: {
                        data: response.data.data,
                    }
                });
            })
            .catch(function (error) {
                dispatch({ type: 'UNIDADESFORANEAS_LIST_ERROR', payload: { error: apiErrorMessage(error) } });
            })
            .finally(function () {
                //dispatch({ type: 'HIDE_LOADING' });
            });
    }
}

export const closeMessages = () => {
    return (dispatch, getState) => {
        dispatch({type: "UNIDADESFORANEAS_CLOSE_MESSAGES"});
    }
}
